import {createAction, props} from '@ngrx/store';

/**
 * Scope des Polling-Streams. Pro Scope laeuft maximal eine Polling-Schleife.
 *
 * - `list`: Belegliste-Polling (refresh der gesamten Tabellenseite).
 * - `preview`: Preview-Seite-Polling (refresh des aktuell angezeigten Belegs).
 */
export type VersandstatusPollingScope = 'list' | 'preview';

/**
 * Actions, die den Lifecycle des Versandstatus-Polling steuern. Werden
 * ausschliesslich vom {@link VersandstatusPollingEffects}-Effect konsumiert
 * — NgRx-Reducer halten keinen Zustand zu diesen Actions.
 */
export class VersandstatusPollingActions {

  /**
   * Startet die Polling-Schleife fuer einen Scope. Mehrfache `startPolling`
   * mit demselben Scope ersetzen die bisherige Schleife (z.B. wenn sich
   * BetriebId/BelegId wechseln).
   */
  public static startPolling = createAction(
    '[Versandstatus Polling] Start polling.',
    props<{
      scope: VersandstatusPollingScope;
      betriebId: string;
      belegId?: string;
    }>(),
  );

  /**
   * Stoppt die Polling-Schleife fuer einen Scope. Wird beim Verlassen der
   * Component aufgerufen.
   */
  public static stopPolling = createAction(
    '[Versandstatus Polling] Stop polling.',
    props<{scope: VersandstatusPollingScope}>(),
  );

  /**
   * Interner Tick — wird vom Effect bei jeder Polling-Iteration ausgeloest
   * und triggert den Read-Dispatch fuer den jeweiligen Scope.
   */
  public static pollingTick = createAction(
    '[Versandstatus Polling] Polling tick.',
    props<{
      scope: VersandstatusPollingScope;
      betriebId: string;
      belegId?: string;
    }>(),
  );
}
